// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.spinner_spinner_BqdGl {
    width: 1.25rem;
    height: 1.25rem;
    display: inline-block;
    position: relative;
    border-radius: 50%;
    border-width: .1875rem;
    border-style: solid;
    border-color: var(--ui-white-transparent-default);
    box-sizing: content-box;
}

.spinner_spinner_BqdGl::before, .spinner_spinner_BqdGl::after {
    width: 1.25rem;
    height: 1.25rem;
    content: '';
    border-radius: 50%;
    display: block;
}

.spinner_spinner_BqdGl::after {
    position: absolute;
    top: -.1875rem;
    left: -.1875rem;
    border: .1875rem solid transparent;
    border-top-color: var(--ui-white-default);
    animation: spinner_spin_b_yAY 1.5s cubic-bezier(0.4, 0.1, 0.4, 1) infinite;
}

.spinner_small_zIKPH {
    width: .5rem;
    height: .5rem;
}

.spinner_small_zIKPH::before, .spinner_small_zIKPH::after {
    width: .5rem;
    height: .5rem;
}

.spinner_large_Zp3ga {
    width: 2.5rem;
    height: 2.5rem;
}

.spinner_large_Zp3ga::before, .spinner_large_Zp3ga::after {
    width: 2.5rem;
    height: 2.5rem;
}

@keyframes spinner_spin_b_yAY {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.spinner_spinner_BqdGl.spinner_success_Av9ic {
    border-color: var(--extensions-transparent);
}

.spinner_spinner_BqdGl.spinner_success_Av9ic::after {
    border-top-color: var(--extensions-primary);
}

.spinner_spinner_BqdGl.spinner_warn_A7JM0 {
    border-color: var(--error-transparent);
}

.spinner_spinner_BqdGl.spinner_warn_A7JM0::after {
    border-top-color: var(--error-primary);
}

.spinner_spinner_BqdGl.spinner_info_xaoAL {
    border-color: var(--ui-white-transparent-default);
}

.spinner_spinner_BqdGl.spinner_info_xaoAL::after {
    border-top-color: var(--ui-white-default);
}

.spinner_spinner_BqdGl.spinner_primary_ixhes {
    border-color: var(--looks-transparent);
}

.spinner_spinner_BqdGl.spinner_primary_ixhes::after {
    border-top-color: var(--looks-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/spinner/spinner.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,iDAAiD;IACjD,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kCAAkC;IAClC,yCAAyC;IACzC,0EAA4D;AAChE;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wCAAwC;AAC5C","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.spinner {\n    width: 1.25rem;\n    height: 1.25rem;\n    display: inline-block;\n    position: relative;\n    border-radius: 50%;\n    border-width: .1875rem;\n    border-style: solid;\n    border-color: var(--ui-white-transparent-default);\n    box-sizing: content-box;\n}\n\n.spinner::before, .spinner::after {\n    width: 1.25rem;\n    height: 1.25rem;\n    content: '';\n    border-radius: 50%;\n    display: block;\n}\n\n.spinner::after {\n    position: absolute;\n    top: -.1875rem;\n    left: -.1875rem;\n    border: .1875rem solid transparent;\n    border-top-color: var(--ui-white-default);\n    animation: spin 1.5s cubic-bezier(0.4, 0.1, 0.4, 1) infinite;\n}\n\n.small {\n    width: .5rem;\n    height: .5rem;\n}\n\n.small::before, .small::after {\n    width: .5rem;\n    height: .5rem;\n}\n\n.large {\n    width: 2.5rem;\n    height: 2.5rem;\n}\n\n.large::before, .large::after {\n    width: 2.5rem;\n    height: 2.5rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.spinner.success {\n    border-color: var(--extensions-transparent);\n}\n\n.spinner.success::after {\n    border-top-color: var(--extensions-primary);\n}\n\n.spinner.warn {\n    border-color: var(--error-transparent);\n}\n\n.spinner.warn::after {\n    border-top-color: var(--error-primary);\n}\n\n.spinner.info {\n    border-color: var(--ui-white-transparent-default);\n}\n\n.spinner.info::after {\n    border-top-color: var(--ui-white-default);\n}\n\n.spinner.primary {\n    border-color: var(--looks-transparent);\n}\n\n.spinner.primary::after {\n    border-top-color: var(--looks-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `spinner_spinner_BqdGl`,
	"spin": `spinner_spin_b_yAY`,
	"small": `spinner_small_zIKPH`,
	"large": `spinner_large_Zp3ga`,
	"success": `spinner_success_Av9ic`,
	"warn": `spinner_warn_A7JM0`,
	"info": `spinner_info_xaoAL`,
	"primary": `spinner_primary_ixhes`
};
export default ___CSS_LOADER_EXPORT___;
